import { createServerFn } from "@tanstack/react-start";
import { getServerCacheQueryClient } from "@/network/cache-query-client";
import { QueryKeysConfig } from "@/config/query-keys";
import { getPostsByTag as makeRequest } from "@/network/queries/get-posts-by-tag";
import { loggingMiddleware } from "../middleware/server-fn/logging";
import * as v from "valibot";

const Schema = v.object({
  tag: v.pipe(v.string(), v.maxLength(256)),
  after: v.optional(v.pipe(v.string(), v.maxLength(256))),
});
export const getPostsByTag = createServerFn({ method: "GET" })
  .middleware([loggingMiddleware])
  .validator((data: v.InferInput<typeof Schema>) => data)
  .handler(async ({ data }) => {
    const res = await getServerCacheQueryClient().ensureQueryData({
      queryKey: [QueryKeysConfig.postsByTag, data],
      queryFn: () => makeRequest(data),
      revalidateIfStale: true,
    });
    return res;
  });
